import React from "react";
import WhyChooseCarousel from "../../components/WhyChooseCarousel";
import { whyChooseContent } from "./homeContent";
import { homeIcons } from "./homeIcons";

/* The strip this page introduced now lives in components/WhyChooseCarousel so
   every other page can render the identical structure. The Home page alone
   shows each reason's icon as a navy + orange badge (2026-09-25); the other
   pages keep the shared illustrations. */
const HomeWhyChoose = () => (
  <WhyChooseCarousel
    id="home-why-choose-heading"
    title={whyChooseContent.title}
    subtitle={whyChooseContent.subtitle}
    reasons={whyChooseContent.reasons.map((reason) => ({
      ...reason,
      badgeIcon: homeIcons[reason.icon],
    }))}
  />
);

export default HomeWhyChoose;
